import ErrorStackParser from "error-stack-parser";

/**
 * Returns a list of parameters formatted for passing as parameters on a URL
 *
 * Can be called with a single string, and array of string valus OR an object of key value pairs:
 *
 * E.g.
 *
 *      const params = getParamList ( 'include-teacher' ) ;
 *
 * or
 *
 *      const params = getParamList ( [ 'include-teacher', 'include-providers' ] ;
 *
 * or
 *
 *      const params = getParamLIst ( { 'include-teacher' : true, max: 12 } ) ;
 *
 * @params {String | Object | Array} flagArray  Array or string objects to be added to the list
 * @params {string} initialJoin ? or & depending on what you want the join character to be
 *
 * @return {String}
 */
export const getParamList = (flagArray, initialJoin) =>
{
  let curJoin = initialJoin === undefined || initialJoin === '?' ? '?' : '&';

  if (typeof flagArray === 'string')
  {
    // If it's just a single string value, just append it
    return curJoin + flagArray ;
  }
  else if (Array.isArray(flagArray))
  {
    // If it's an array, return an array of the names
    return flagArray.reduce((accumulator, currentValue, currentIndex, array) =>
    {
      const add = accumulator + curJoin + currentValue;

      curJoin = '&';

      return add;
    }, '');
  }
  else
  {
    // We can also pass an object if key-values are required

    const keys = Object.keys(flagArray);
    const values = Object.values(flagArray);

    return keys.reduce((accumulator, currentValue, currentIndex, array) =>
    {
      const v = currentValue + '=' + values[currentIndex];

      const add = accumulator + curJoin + v;

      curJoin = '&';

      return add;
    }, '');

  }

}
export const getDataWithPromise = (url, type, data) => {
  return new Promise((resolve, reject) => {
    if (url == null || url === "") {
      throw Error("getDataWithPromise cannot call an empty URL");
    } else {
      $.ajax({
        type: type,
        url: url,
        data: data,
        success: (data) =>
        {
          const result = promiseCheckError( data ) ;

          if ( result.result === true )
          {
            resolve(data);
          }
          else
          {
            bootbox.alert({
              size: 'large',
              title: '<b>Fail</b>',
              message: result.displayMessage,
              backdrop: true,
              callback: function () {
              }
            });

            reject ( null, null, "checkError" );
          }
        },
        error: (jqXHR, textStatus, error) => {
          reject(jqXHR, textStatus, error);
        }
      });
    }
  });
};

export const getDataFromResponse = ( response ) =>
{
  if (response.results !== undefined && response.results != null)
  {
    return response.results.record_set;
  }
  else
  {
    return [] ;
  }
}

export const getNumRowsFromResponse = ( response ) =>
{
  if (response.results !== undefined && response.results != null)
  {
    return +response.results.rows ;
  }
  else{
    return 0;
  }
}

export const SUCCESS_STATUS = 'OK' ;
export const FAIL_STATUS = 'fail' ;
export const INVALID_STATUS = 'INVALID' ;

export const getStatusFromResponse = ( response ) =>
{
  let rval = INVALID_STATUS ;

  if ( response.results !== undefined && response.results.error !== undefined )
  {
    rval = response.results.error ;
  }
  else
  {
    if ( response.status !== undefined )
    {
      return response.status.result;
    }
  }

  return rval ;
}

export const getResultFromResponse = (response) =>
{
  // Passport

  if (response.status !== undefined && response.status != null)
  {
    return response.status.result;
  }
  else
  {
    return null;
  }
}

export const getErrorDetailromResponse = (response) =>
{
  // Passport

  if (response.status !== undefined && response.status != null)
  {
    return response.status.errorDetail;
  }
  else
  {
    return null;
  }
}

export const getErrorFromResponse = ( response ) =>
{
  if ( response.results !== undefined )
  {
    return response.results.errorType ;
  }
  else if ( response.status !== undefined )
  {
    return response.status.error ;
  }
}

export const getExceptionClassFromResponse = (response) =>
{
  // Passport
  if (response.exceptionClass !== undefined && response.exceptionClass != null)
  {
    return response.exceptionClass;
  }
  else
  {
    return null;
  }
}

export const getStackTraceFromResponse = (response) =>
{
  // Passport
  if (response.status.errorDetail !== undefined && response.status.errorDetail != null)
  {
    if (response.status.errorDetail.trace !== undefined)
    {
      return response.status.errorDetail.trace;
    }
    else
    {
      return null;
    }
  }
  else
  {
    return null;
  }
}

export const getErrorDetailFromResponse = ( response ) =>
{
  if ( response.results !== undefined )
  {
    return response.results.errorDetail ;
  }
  else if ( response.status !== undefined )
  {
    return response.status.errorDetail ;
  }
}

export const promiseCheckError = ( data ) =>
{
  const error_result = getStatusFromResponse( data ) ;
  let displayMessage = '';
  let result = false ;

  if ( data === null )
  {
    result = false ;
    displayMessage = "<p>Null Response From Server</p>";
  }
  else if ( error_result === SUCCESS_STATUS )
  {
    result = true ;
  }
  else if ( error_result === INVALID_STATUS )
  {
    result = false ;
    displayMessage = "<p>" +  data + '</p>';
  }
  else
  {
    if ( getErrorFromResponse( data ) === "PDO Exception")
    {
      const details = getErrorDetailFromResponse( data );

      displayMessage = "<p>Error File: " + details.file + '</p>';
      displayMessage += "<p>Error Line: " + details.line + '</p>' ;
      displayMessage += '<p>' + details.message + '</p>' ;
    }
    else if ( getErrorFromResponse( data ) === "Exception")
    {
      displayMessage = "<p>Error File: " + data.errorDetail.file + '</p>';
      displayMessage += "<p>Error Line: " + data.errorDetail.line + '</p>' ;
      displayMessage += '<p>' + data.errorDetail.message + '</p>' ;
    }
    else if ( getErrorFromResponse( data ) === "Invaild JWT Token")
    {
      var emailContact = '<a href="mailto:info@arcbox.co.uk">info@arcbox.co.uk</a>'
      displayMessage = "<p>Invaild Token: Your security token has expired. Please contact the person who invited you to ARCBOX. Or email  " + emailContact + '</p>';
    }
    else if (getErrorFromResponse(data) === "Custom S360 Error")
    {
      displayMessage = "<p>Error: " + data.results.error + "</p>";
      displayMessage += "<p>File: " + data.results.errorDetail.file + "</p>";
      displayMessage += "<p>Line: " + data.results.errorDetail.line + "</p>";
      displayMessage += "<p>Message: " + data.results.errorDetail.message + "</p>";
      displayMessage += "<p>Trace: " + data.results.errorDetail.trace + "</p>";
    }
    else
    {
      displayMessage = "<p>Error: " + data.error + "</p>" ;
      displayMessage += "<p>Detail: " + data.errorDetail + "</p>" ;
    }
  }

  return {result: result, displayMessage: displayMessage } ;
}

//this is only used by the react register/activate form
export const checkError = ( data ) =>
{
  const checkResult = promiseCheckError( data ) ;

  if ( checkResult.result !== true )
  {
    console.error ( data ) ;

    try
    {
      bootbox.alert({
        size: "large",
        title: "The operation failed",
        message: displayMessage,
      });
    } catch (e)
    {
      console.log(e);
    }
  }

  return checkResult.result ;
}

function getThisErrorObject() {
  try {
    throw Error("");
  } catch (err) {
    const res = ErrorStackParser.parse(err);

    return res;
  }
}

export const handleAjaxError = (jqXHR, exception, error, returnUrl) => {
  let msg = "";
  let fullMessage = "";

  if (jqXHR.status === 0 || jqXHR.readyState === 0) {
    return;
  }

  if (jqXHR.status === 0) {
    msg = "Not connect.\n Verify Network.";
  } else if (jqXHR.status == 400) {
    msg = "Bad Parameters. [400]" + "</p>";

    if (jqXHR.responseJSON != null) {
      const status = jqXHR.responseJSON;

      if (status.error === "Exception") {
        fullMessage = "<p>Error File: " + status.errorDetail.file + "</p>";
        fullMessage += "<p>Error Line: " + status.errorDetail.line + "</p>";
        fullMessage += "<p>" + status.errorDetail.message + "</p>";
      }
    }
  } else if (jqXHR.status === 404) {
    if (jqXHR.responseJSON != null) {
      const status = jqXHR.responseJSON;

      if (status.error === "Exception") {
        fullMessage = "<p>Error URL: " + status.errorDetail.file + "</p>";
        fullMessage += "<p>" + status.errorDetail.message + "</p>";
      }
    } else {
      msg = "Page Not Found. [404]" + "</p>";
    }
  } else if (jqXHR.status === 401) {
    msg = "Not Authorised. [404]";
  } else if (jqXHR.status === 500) {
    msg = "Internal Server Error [500].";

    if (jqXHR.responseJSON != null) {
      const status = jqXHR.responseJSON;

      if (status.error === "Exception") {
        fullMessage = "<p>Error File: " + status.errorDetail.file + "</p>";
        fullMessage += "<p>Error Line: " + status.errorDetail.line + "</p>";
        fullMessage += "<p>" + status.errorDetail.message + "</p>";
      }
    } else if (jqXHR.responseText != null) {
      fullMessage = "<p>Error File: " + jqXHR.responseText + "</p>";
    }
  } else if (exception === "parsererror") {
    msg = "Requested JSON parse failed.";
  } else if (exception === "timeout") {
    msg = "Time out error.";
  } else if (exception === "abort") {
    msg = "Ajax request aborted.";
  } else {
    if (jqXHR.message != null) {
      msg = jqXHR.message;

      fullMessage = "<p>Error Stack: " + jqXHR.stack + "</p>";
    } else {
      msg = "Uncaught Error.\n" + jqXHR.responseText;
    }
  }

  const stackFrames = getThisErrorObject();

  const callingFrame = stackFrames[2];

  if (fullMessage === "") {
    fullMessage =
      "Error occurred in function " +
      callingFrame.functionName +
      " in module " +
      callingFrame.fileName +
      " at line " +
      callingFrame.lineNumber;
  }

  if (jqXHR.status === 401) {
    fullMessage = "You are not authorised to perform this operation.";
  }

  bootbox.alert({
    size: "large",
    title: "The operation failed " + msg,
    message: fullMessage,
    callback: function () {
      if (returnUrl != null) {
        location.assign(returnUrl);
      }
    }
  });
};

